import React from "react";
import { Link } from "react-router-dom";
import Seo from "components/Seo";
import NavBar from "components/navBar";
import BannerNotice from "components/HomeBanner/bannerNotice";
import BannerIntro from "components/HomeBanner/bannerIntro";
import BannerCall from "components/HomeBanner/bannerCall";
import BannerDirect from "../../../components/HomeBanner/bannerDirect";
import BannerService from "components/HomeBanner/bannerService";
import OftenMenu from "components/HomeBanner/oftenMenu";
import VerticalSlideMenu from "components/HomeBanner/VerticalSlideMenu";
import MainPopups from "components/popup/MainPopups";
import Bg_morning from "assets/banner/bg_morning.png";
import BannerMorning1 from "assets/banner/banner_morning1.png";
import BannerMorning2 from "assets/banner/banner_morning2.png";
import BannerMorning3 from "assets/banner/banner_morning3.png";
import OftenMorning1 from "assets/banner/often_morning1.png";
import OftenMorning2 from "assets/banner/often_morning2.png";
import OftenMorning3 from "assets/banner/often_morning3.png";
import DirectMorning1 from "assets/banner/direct_morning1.png";
import DirectMorning2 from "assets/banner/direct_morning2.png";
import transport_service from "assets/banner/transport_service.png";
import transport_service2 from "assets/banner/transport_service2.png";
import { useAppContext } from "context/AppContext";

const PRINT_DRIVER_DOWNLOAD_URL =
    "https://imdg-files.s3.ap-northeast-2.amazonaws.com/files/%E1%84%8E%E1%85%A1%E1%86%A8%E1%84%92%E1%85%A1%E1%86%AB%E1%84%85%E1%85%A1%E1%84%87%E1%85%A6%E1%86%AF%E1%84%91%E1%85%B3%E1%84%85%E1%85%B5%E1%86%AB%E1%84%90%E1%85%A5_4B2054N%E1%84%83%E1%85%B3%E1%84%85%E1%85%A1%E1%84%8B%E1%85%B5%E1%84%87%E1%85%A5.zip";

const Morning = () => {
    const { isApp } = useAppContext();

    return (
        <React.Fragment>
            <Seo type="morning" />
            <div className="flex-1 flex flex-col">
                {!isApp && (
                    <div className="flex justify-center fixed top-0 left-0 w-full z-30 bg-white">
                        <NavBar
                            transport={[
                                { label: "모닝 서비스", path: "/transport/morning-service" },
                                { label: "전국센터조직도", path: "/transport/center-network" },
                                { label: "주요 CLIENT 현황", path: "/transport/clients" },
                            ]}
                            customer={[
                                { label: "인터넷오더접수", path: "/customer/online-order" },
                                { label: "운송장조회", path: "/customer/tracking" },
                                { label: "청구서조회", path: "/customer/invoices" },
                                { label: "청구서수정요청", path: "/customer/invoices-edit" },
                                { label: "운송장 신청접수", path: "/customer/tracking-request" },
                                { label: "입고지별 담당기사 조회", path: "/customer/driver-info" },
                            ]}
                            support={[
                                { label: "사용문의", path: "/support/courier-inquiry" },
                                { label: "공지사항", path: "/support/notices" },
                                { label: "FAQ", path: "/support/faq" },
                                // { label: "일신그룹 고객센터", path: "/support/tels" },
                            ]}
                        />
                    </div>
                )}
                {/* 1번째 div */}
                <div
                    className={`min-h-[800px] pb-[60px] relative overflow-hidden bg-cover bg-top flex flex-col items-center justify-center bg-no-repeat h-auto ${!isApp && "mt-[116px]"} responsive1200:min-h-[auto] responsive1200:pb-[90px]`}
                >
                    <div
                        className="absolute inset-0 bg-top bg-cover animate-zoom-in"
                        style={{ backgroundImage: `url(${Bg_morning})` }}
                    ></div>
                    <div className="absolute inset-0 z-10 bg-black bg-opacity-40"></div>
                    <div className="relative flex flex-col z-20 items-center justify-center h-full text-white text-center py-[45px] responsive1200:pb-[28px] responsive1200:pt-[40px]">
                        <p className="text-[49px] font-bold responsive1200:text-[29px] break-keep">마음까지 전해주는 모닝택배</p>
                        <p className="text-[18px] mt-2 responsive1200:text-[14px]">내 마음의 명품택배입니다</p>
                    </div>

                    {/* 1200 이하 */}
                    <div className="responsive1200:px-[4%] grid grid-cols-2 gap-[12px] z-20 w-full hidden responsive1200:grid">
                        <BannerService
                            isResonsive
                            type="morning"
                            title="운송서비스"
                            description=""
                            Image={<img src={transport_service} alt="운송서비스 이미지" width={60} />}
                            linkTo="/transport/morning-service"
                        />
                        <BannerService
                            isResonsive
                            type="morning"
                            title="인터넷오더접수"
                            description="접수하시면 빠르게 <br /> 처리하겠습니다"
                            Image={<img src={BannerMorning1} alt="인터넷오더접수 이미지" width={60} />}
                            linkTo="/customer/online-order"
                        />
                        <BannerService
                            isResonsive
                            type="morning"
                            title="운송장조회"
                            description="B/L번호로 운송장현황을 <br /> 조회/출력/취소 하실 수 있습니다"
                            Image={<img src={BannerMorning2} alt="운송장조회 이미지" width={60} />}
                            linkTo="/customer/tracking"
                        />
                        <BannerService
                            isResonsive
                            type="morning"
                            title="청구서조회"
                            description="청구서 내역을 자세히 <br /> 확인할 수 있습니다"
                            Image={<img src={BannerMorning3} alt="청구서조회 이미지" width={60} />}
                            linkTo="/customer/invoices"
                        />
                    </div>
                    {/* 1200 이상 */}
                    <div className="w-full max-w-[1200px] flex justify-between z-20 responsive1200:hidden">
                        <div className="flex flex-col gap-[22px]">
                            <div className="flex flex-col gap-2">
                                <Link to="/transport/morning-service" className="bg-white px-[35px] py-[12px] w-[285px] rounded-[20px]">
                                    <div className="relative">
                                        <p className="text-[#fca42f] font-bold">운송서비스</p>
                                        <p className="text-[#666] text-sm mt-2.5">
                                            저렴하고, 빠르고, 정확한 <br /> 일신과 함께 하십시오
                                        </p>
                                        <img className="absolute top-3 right-0" src={transport_service} alt="transport_service" />
                                    </div>
                                </Link>
                                <Link to="/customer/driver-info" className="bg-white px-[35px] py-[12px] w-[285px] rounded-[20px]">
                                    <div className="relative">
                                    <p className="text-[#fca42f] font-bold">인천공항/항/신항 담당기사 조회</p>
                                        <p className="text-[#666] text-sm mt-2.5">
                                            입고일에 맞는 실시간 배송기사 <br /> 정보를 조회해보세요.
                                        </p>
                                        {/* <img
                                            className="absolute top-2 right-0 w-[60px] h-[60px]"
                                            src={transport_service2}
                                            alt="transport_service2"
                                        /> */}
                                    </div>
                                </Link>
                                {/* <Link
                                    to="https://helpu.kr/ilshinair"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="bg-white px-[35px] py-[12px] w-[285px] rounded-[20px]"
                                >
                                    <div className="relative">
                                        <p className="text-[#fca42f] font-bold">원격지원</p>
                                        <p className="text-[#666] text-sm mt-2.5">
                                            QR시스템 설정 <br /> 도움이 필요하신가요?
                                        </p>
                                        <img
                                            className="absolute top-2 right-0 w-[60px] h-[60px]"
                                            src={transport_service2}
                                            alt="transport_service2"
                                        />
                                    </div>
                                </Link> */}
                            </div>

                            <OftenMenu
                                type="morning"
                                content1="사용문의"
                                content2="운송장 신청"
                                content3="프린터설치 <br /> 가이드"
                                Image1={<img src={OftenMorning1} alt="OftenMorning1" />}
                                Image2={<img src={OftenMorning3} alt="OftenMorning2" />}
                                Image3={<img src={OftenMorning2} alt="OftenMorning3" />}
                                navigate1="/support/courier-inquiry"
                                navigate2="/customer/tracking-request"
                                navigate3="https://intriguing-dryer-881.notion.site/120a61a48d338056bbffe26a2216aecb"
                                downloadUrl={PRINT_DRIVER_DOWNLOAD_URL}
                                downloadLabel="프린트드라이버 다운로드"
                            />
                        </div>
                        <BannerService
                            type="morning"
                            title="인터넷오더접수"
                            description="접수하시면 빠르게 <br /> 처리하겠습니다"
                            Image={<img src={BannerMorning1} alt="BannerMorning1" />}
                            linkTo="/customer/online-order"
                        />
                        <BannerService
                            type="morning"
                            title="운송장조회/출력/취소"
                            description="B/L번호로 운송장현황을 <br /> 조회/출력/취소 하실 수 있습니다"
                            Image={<img src={BannerMorning2} alt="BannerMorning2" />}
                            linkTo="/customer/tracking"
                        />
                        <BannerService
                            type="morning"
                            title="청구서조회"
                            description="청구서 내역을 자세히 <br /> 확인할 수 있습니다"
                            Image={<img src={BannerMorning3} alt="BannerMorning3" />}
                            linkTo="/customer/invoices"
                        />
                    </div>

                    <VerticalSlideMenu type="morning" />
                </div>
                {/* 2번째 div */}
                <div className="flex-1 flex flex-col items-center py-[75px] bg-[#f8f8f8] responsive1200:px-[4%] responsive1200:py-[20px]">
                    <p className="text-[29px] font-bold mb-8 responsive1200:hidden">일신모닝택배</p>

                    {/* 1200 이하 */}
                    <div className="w-full hidden responsive1200:block">
                        <OftenMenu
                            responsive
                            type="morning"
                            content1="택배사용 문의"
                            content2="운송장 신청접수"
                            Image1={<img src={OftenMorning1} alt="OftenMorning1" />}
                            Image2={<img src={OftenMorning3} alt="OftenMorning2" />}
                        />
                    </div>

                    <div className="flex flex-col gap-6 responsive1200:w-full responsive1200:gap-[20px] responsive1200:mt-[20px]">
                        <div className="flex gap-6 responsive1200:w-full responsive1200:gap-0">
                            <BannerNotice type="morning" />
                            <BannerIntro type="morning" className="responsive1200:hidden" />
                        </div>
                        {/* 1200 이상 */}
                        <div className="flex gap-6 responsive1200:hidden">
                            <BannerDirect
                                linkTo="/transport/morning-service"
                                title="모닝서비스"
                                content="사람과 사람을 이어주는 역할과 <br /> 책임을 다하는 진정한 택배 서비스 <br /> 일신이 추구하는 가치입니다"
                                image={<img src={DirectMorning1} alt="direct_morning" className="absolute right-10 top-12" />}
                                color="air"
                            />
                            <BannerDirect
                                linkTo="/transport/center-network"
                                title="전국센터조직도"
                                content="전국적으로 이용하실 수 있는 <br /> 일신모닝택배의 영업소들을 <br /> 확인해보세요"
                                image={<img src={DirectMorning2} alt="direct_morning" className="absolute right-9 top-20" />}
                                color="quick"
                            />
                            <BannerCall type="morning" />
                        </div>

                        {/* 1200 이하 */}
                        <div className="gap-[10px] hidden responsive1200:flex">
                            <Link to="/company/ceo-message" className="flex-1 text-white bg-base text-center p-[10px] rounded-[20px]">
                                회사소개
                            </Link>
                            <Link to="/company/branch" className="flex-1 text-white bg-express text-center p-[10px] rounded-[20px]">
                                BRANCH
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
            <MainPopups type="morning" />
        </React.Fragment>
    );
};

export default Morning;
